import React from 'react';
import { useTranslation } from '@lt/localization';
import styles from './noFlightsBlock.module.css';

import HighlightedText from '../HighlightedText';

import {
  NEAREST_DATES_NO_FLIGHTS_TEXT,
  NEAREST_DEPARTURES_NO_FLIGHTS_TEXT,
} from '../../constants';
import type { INoFlightsBlock } from './types';

export const NoFlightsBlock = (props: INoFlightsBlock) => {
  const { initial, destinationChanged, departureChanged, dateChanged } = props;
  const { t } = useTranslation();

  const showDestination = destinationChanged && 'destination' in initial;
  const showDate = dateChanged && 'date' in initial;

  return (
    <>
      <span className={styles.capitalLetter}>{`${t(
        'hotel.cigarette.mobile.from',
      )} `}</span>
      <HighlightedText>{String(initial.departure.nameForm2)} </HighlightedText>
      {showDestination && (
        <HighlightedText
          capitalize={departureChanged}
          data-testid={NEAREST_DEPARTURES_NO_FLIGHTS_TEXT}
        >
          {initial.destination.nameForm3}{' '}
        </HighlightedText>
      )}
      {showDate && (
        <HighlightedText data-testid={NEAREST_DATES_NO_FLIGHTS_TEXT}>
          {`${t('search.empty.night')} ${initial.date.nameForm1} `}
        </HighlightedText>
      )}
      <HighlightedText>{t('explore.hotels.noFlights')}</HighlightedText>
    </>
  );
};
